<template>
  <div v-if="wikiinfo">
    <div class="wiki-title">
      <div class="row-title">
        <h2>{{ wikiinfo.title || '未知标题' }}</h2>

        <div class="row-title-tag">
          <em class="wait" v-if="wikiinfo.status == 0">等待采集</em>
          <em class="processing" v-if="wikiinfo.status == 1">正在采集</em>
          <em class="success" v-if="wikiinfo.status == 2">采集成功</em>
          <em class="failure" v-if="wikiinfo.status == -1">采集失败 </em>
        </div>

        <div v-if="crawlFlag == true" class="download">
          <a-button v-if="crawlFlag == true" type="primary" @click="tempDownload">下载</a-button>
        </div>
      </div>

      <div class="row">
        <div class="title" v-if="!crawlFlag">
          <h1>分类</h1>
        </div>
        <div v-for="(subject, index) in wikiinfo.subjects" :key="index" v-if="!crawlFlag">
          <div class="keywords-container">
            <div class="keyword">{{ subject.subjectName }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="wiki-pedia-info">
      <div class="content">
        <div class="introduct" v-for="(item, index) in segment.text" :key="index">
          {{ item }}
        </div>
        <div class="part" v-for="(item, index) in segment.children" :key="index">
          <h2>{{ item.title }}</h2>
          <p v-for="(p, i) in item.text" :key="i">{{ p }}</p>

          <div v-if="item.children != null && item.children.length > 0">
            <div class="part" v-for="(childItem, childIndex) in item.children" :key="childIndex">
              <h3>{{ childItem.title }}</h3>
              <p v-for="(childP, childI) in childItem.text" :key="childI">{{ childP }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="card" v-if="infobox_table != null">
        <img :src="wikiinfo.thumbnail_url" alt="" />
        <ul>
          <li v-for="(item, index) in infobox_table" :key="index">
            <div class="card-title" v-if="item.length == 1">{{ item[0] }}</div>
            <div class="key-val" v-if="item.length == 2">
              <span class="key">{{ item[0] }}</span>
              <span class="val">{{ item[1] }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { queryTempCrawlByUrlApi } from '@/api/TopicCrawl/Wikipedia'
import { queryCollectDetaileByIdApi } from '@/api/TopicCrawl/CollectInfo'
import stringUtil from '@/utils/string'

export default {
  data() {
    return {
      url: '',
      wikiinfo: {},
      segment: {},
      infobox_table: [],
      infobox_hrefs: {},
      crawlFlag: false
    }
  },
  created() {
    let { subjectId, subjectContentId, type, queryType } = this.$route.query
    this.subjectId = subjectId
    this.subjectContentId = subjectContentId
    this.type = type
    this.queryType = queryType
    if (queryType == 'tempCrawl') {
      this.crawlFlag = true
      this.queryTempCrawlByUrl()
    } else {
      this.querSubjectDetail(subjectContentId)
    }
  },
  methods: {
    tempDownload() {
      let tempCrawlStr = localStorage.getItem('tempCrawl')
      const element = document.createElement('a')
      element.setAttribute(
        'href',
        'data:text/plain;charset=utf-8,' + encodeURIComponent(tempCrawlStr)
      )
      element.setAttribute('download', '临时爬取数据.txt')
      element.style.display = 'none'
      element.click()
    },

    async queryTempCrawlByUrl() {
      let tempCrawlStr = localStorage.getItem('tempCrawl')

      if (!stringUtil.isNull(tempCrawlStr)) {
        let tempCrawl = JSON.parse(tempCrawlStr)

        this.wikiinfo = tempCrawl.content
        if (null != this.wikiinfo.content_info) {
          this.segment = this.wikiinfo.content_info.segment
          this.infobox_table = this.wikiinfo.content_info.infobox_info.infobox_table
          this.infobox_hrefs = this.wikiinfo.content_info.infobox_info.infobox_hrefs
        }
      }
    },
    async querSubjectDetail(subjectContentId) {
      let res = await queryCollectDetaileByIdApi({ subjectContentId })
      let { code, msg, extra } = res
      if (code == '200') {
        this.wikiinfo = extra.content
        if (null != this.wikiinfo && null != this.wikiinfo.content_info) {
          this.segment = this.wikiinfo.content_info.segment
          this.infobox_table = this.wikiinfo.content_info.infobox_info.infobox_table
          this.infobox_hrefs = this.wikiinfo.content_info.infobox_info.infobox_hrefs
        }
      } else {
        this.$message.error(msg)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.wiki-title {
  padding: 10px 0px 0px 0px;
  background: white;

  .download {
    border-radius: 4px !important;

    flex-direction: row-reverse;
    display: flow-root;
    margin-inline-start: auto;
    margin-right: 20px;
  }

  .row-title {
    display: flex;
    margin-bottom: 0px;
    align-items: center;
    font-size: 16px;

    margin-left: 1.5em;

    padding-bottom: 10px;
    .title {
      margin-bottom: 2px;
    }

    .row-title-tag {
      font-size: 14px;
      margin-left: 15px;
      em {
        padding: 3px 5px;
        width: 90px;
        margin-right: 10px;
        border-radius: 2px;
        font-style: normal;

        text-align: center;

        &.success {
          background: #f0faef;
          border: 0.1px solid #66c25d;
          border-radius: 4px;
        }

        &.none {
          background: #f9e4e6;
          border: 0.1px solid #e89fa6;
          border-radius: 4px;
        }

        &.wait {
          background: #f0f2f5;
          border: 1px solid #b5bbc3;
          border-radius: 4px;
        }
        &.failure {
          background: #fff6e2;
          border: 0.5px solid #ffc852;
          border-radius: 4px;
        }
        &.processing {
          background: #f0f7ff;
          border: 1px solid #3c93ff;
          border-radius: 4px;
        }
      }
    }
  }

  .row {
    display: flex;
    align-items: center;
    font-size: 13px;
    margin-left: 2em;
    border-bottom: 1px solid #e6e6e6;
    padding-bottom: 10px;
    .title {
      margin-bottom: -8px;
    }
    .keywords-container {
      flex: 1;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 10px;
      margin-left: 1em;
      .keyword {
        text-align: center;
        border: 1px solid #eeeeee;
        color: #999999;
        border-radius: 5px;
        padding: 5px 20px;
      }
    }
  }
}

.wiki-pedia-info {
  white-space: pre-line;
  padding: 10px;
  display: flex;
  overflow: auto;
  background: #fff;

  .content {
    flex: 1;
    padding: 20px;
    .title {
      font-size: 20px;
    }
    .introduct {
      text-indent: 2em;
      line-height: 1.9;
    }
    .part {
      margin-top: 30px;
      h2 {
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 10px;
        font-size: 18px;
      }
      p {
        text-indent: 2em;
        line-height: 1.9;
      }
    }
  }
  .card {
    flex: 0 0 340px;
    padding-left: 0px;
    background: #fafafa;
    img {
      height: 200px;
      width: 100%;
      border: 1px solid #f0f0f0;
    }
    .card-title {
      background: lightsteelblue;
      margin-bottom: 10px;
      padding: 5px;
      font-weight: 600;
      text-align: center;
    }
    .key-val {
      display: flex;
      padding: 5px;
      .key {
        flex: 0 0 100px;
        font-weight: 600;
        color: #333333;
      }
      .val {
        flex: 1;
        color: #999999;
      }
    }
  }
}
</style>
